import { getAriaLabel } from '@bridge/utils';
import { Checkbox, FormControl, FormDescription, FormItem, FormLabel, FormMessage } from '../../components';
import { getFieldIds } from './utils';
import type { FieldValues } from 'react-hook-form';
import type { BaseComponentProps, BaseFieldProps } from './types';
export type CheckboxComponentProps = BaseComponentProps<typeof Checkbox>;
interface CheckboxFieldProps<TFieldValues extends FieldValues> extends BaseFieldProps<TFieldValues> {
  componentProps: CheckboxComponentProps;
}
export function CheckboxField<TFieldValues extends FieldValues>({
  field,
  fieldConfig,
  fieldState,
  componentProps,
  labelSize
}: CheckboxFieldProps<TFieldValues>) {
  const {
    id,
    disabled: componentDisabled,
    ...restComponentProps
  } = componentProps;
  const isDisabled = field.disabled || componentDisabled;
  const {
    fieldId,
    labelId,
    descriptionId,
    errorId,
    describedBy,
    isInvalid
  } = getFieldIds(fieldConfig, fieldState, id);
  return <FormItem className="flex-1">
      <div className="flex items-center space-x-2 pt-2">
        <FormControl>
          <Checkbox {...restComponentProps} aria-describedby={describedBy} aria-invalid={isInvalid} aria-label={getAriaLabel(fieldConfig.label)} checked={Boolean(field.value)} disabled={isDisabled} id={fieldId} onCheckedChange={field.onChange} ref={field.ref} />
        </FormControl>
        <FormLabel htmlFor={fieldId} id={labelId} required={fieldConfig.required} size={labelSize} weight="medium">
          {fieldConfig.label}
        </FormLabel>
      </div>
      {descriptionId && <FormDescription id={descriptionId}>{fieldConfig.description}</FormDescription>}
      {errorId && <FormMessage id={errorId}>{fieldState.error?.message}</FormMessage>}
    </FormItem>;
}